<template>
  <el-container>
    <el-header class="home-header">
      <TopBar :is-admin="$route.meta.isAdmin"></TopBar>
    </el-header>
    <el-main style="margin-top: 55px; flex: 1; overflow: hidden">
      <splitpanes v-if="$route.meta.hasSide" class="default-theme">
        <pane size="20" min-size="12" max-size="50">
          <el-menu
            :key="menuKey"
            active-text-color="#ffd04b"
            background-color="#fff"
            class="el-menu-vertical-demo"
            v-model:default-active="defaultActive"
            v-model:default-openeds="defaultOpeneds"
            :unique-opened="true"
            text-color="#000"
            :collapse="false"
            :router="false"
            @select="select"
            @open="open"
            @close="close"
          >
            <SideMenu :menus="menus"></SideMenu>
          </el-menu>
        </pane>
        <pane>
          <router-view v-slot="{ Component }">
            <keep-alive v-if="$route.meta.keepAlive">
              <component :is="Component" />
            </keep-alive>
            <component :is="Component" v-else />
          </router-view>
        </pane>
      </splitpanes>
      <template v-else>
        <router-view v-slot="{ Component, route }">
          <keep-alive v-if="route.meta.keepAlive" include="NoteHome">
            <component :is="Component" />
          </keep-alive>
          <component :is="Component" v-else />
        </router-view>
      </template>
    </el-main>
    <el-footer class="home-footer" style="height: 39px">
      <p class="lh">
        简单笔记 -
        <a class="text-color" href="https://beian.miit.gov.cn" target="_blank">京ICP备2024060555号-1</a>
      </p>
    </el-footer>
  </el-container>
</template>

<script setup>
  import { ref, watch, nextTick, computed, onMounted, toRaw } from 'vue';
  import TopBar from '../components/TopBar.vue';
  import { useRouter } from 'vue-router';
  import { Splitpanes, Pane } from 'splitpanes';
  import 'splitpanes/dist/splitpanes.css';
  import SideMenu from '@/components/SideMenu.vue';
  import { articleApi } from '../api/index.js';
  import { useRoute } from 'vue-router';
  import { isEmpty, findPath } from '@/utils/tool';

  const $route = useRoute();
  const $router = useRouter();

  const menuKey = ref(Date.now());
  const sectionId = ref(0);
  const defaultActive = ref('');
  const menus = ref([]);
  const defaultOpeneds = ref([]);

  const findMenus = async currentRouteVal => {
    let sid = 0;
    let articleId = 0;
    if (currentRouteVal && currentRouteVal.path.startsWith('/section')) {
      sid = currentRouteVal.params.section.substring(8);

      if (!isEmpty(currentRouteVal.params.id)) {
        articleId = Number(currentRouteVal.params.id);
      }
    }
    // console.log(`sectionId.value:${sectionId.value}; sid: ${sid}`);
    if (sid > 0 && (sid !== sectionId.value || menus.value.length <= 0)) {
      const result = await articleApi.findMenus(sid, 1);
      if (result?.errcode === 0) {
        // console.log('menus:', result.data);
        sectionId.value = sid;
        menus.value = result.data || [];

        if (!articleId && !isEmpty(result.data[0].children)) {
          articleId = result.data[0].children[0].id;
        }
        if (articleId > 0) {
          $router.push(`/section_${sid}/${articleId}`);
          defaultActive.value = articleId;
          defaultOpeneds.value = findPath(result.data, articleId);
          // 解决切换菜单时默认菜单不展开问题
          menuKey.value = Date.now();
        }
      }
    }
  };

  // 监听当前路由
  watch(
    () => $router.currentRoute.value,
    (newValue, oldValue) => {
      // console.log('to newValue', newValue, 'oldValue:', oldValue);
      if (newValue) {
        findMenus(newValue);
      }
    },
    { immediate: true }
  );

  // 选中左侧菜单事触发 (index, indexPath)
  const select = (index, indexPath, item) => {
    // console.log('index:', index);
    // console.log('indexPath:', indexPath);
    defaultOpeneds.value = indexPath;
    defaultActive.value = index;
    $router.push(`/section_${sectionId.value}/${index}`);
  };
  const open = i => {
    console.log('open:', i);
  };
  const close = i => {
    console.log('close:', i);
  };
</script>
<style lang="less">
  :root {
    --el-menu-item-height: 36px !important;
    --el-menu-base-level-padding: 15px !important;
  }
  .el-menu-vertical-demo {
    height: 100%;
  }
  .home-footer {
    margin: 0 auto;
    display: flex;
    align-items: center;
    .lh {
      display: inline-block;
      margin-right: 14px;
      font-size: 12px;
      color: #bbb;
    }
    .text-color {
      color: #bbb;
    }
    a {
      font-size: 12px;
      text-decoration: none;
    }
  }
</style>
